import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddStaffcardModalComponent } from 'src/app/admin/components/modals/add-staffcard-modal/add-staffcard-modal/add-staffcard-modal.component';
import { DeleteStaffcardModalComponent } from 'src/app/admin/components/modals/delete-staffcard-modal/delete-staffcard-modal/delete-staffcard-modal.component';
import { EditStaffcardModalComponent } from 'src/app/admin/components/modals/edit-staffcard-modal/edit-staffcard-modal/edit-staffcard-modal.component';
import { StaffCardParams } from 'src/app/admin/models/staffCardParams';
import { StaffcardService } from 'src/app/admin/services/staffcard.service';

@Component({
  selector: 'app-manage-staffcards',
  templateUrl: './manage-staffcards.component.html',
  styleUrls: ['./manage-staffcards.component.scss'],
})
export class ManageStaffcardsComponent implements OnInit {
  staffCard: StaffCardParams;
  rooms=[];
  paginationSettings = {totalItems: 0};
  currentPage: number = 1;
  staffCards$ = this.staffCardService.staffCard$;
  
  
    constructor(private modalController: ModalController, private staffCardService: StaffcardService) { }
  
    ngOnInit():void {
     
  
      this.staffCardService.getAllStaffCard ({currentPage: 1, itemsPerPage: 100,
       enterQuery: '',  fullNameQuery: '',roomNameQuery:''});
    }
    async openAddStaffCardModal() {
      const modal = await this.modalController.create({
       component: AddStaffcardModalComponent,
     
       cssClass: 'medium-modal-css',
       backdropDismiss: true,
       swipeToClose: false,
     }); 
  
     await modal.present();
   }
   async openDeleteStaffCardModal(staffCard) {
     const modal = await this.modalController.create({
       component: DeleteStaffcardModalComponent,
        componentProps: {staffCard}, 
       cssClass: 'small-modal-css',
       backdropDismiss: true,
       swipeToClose: false,
     });
     await modal.present();
   }
  
   async openEditStaffCardModal(staffCard) {
     const modal = await this.modalController.create({
       component: EditStaffcardModalComponent,
       componentProps: {staffCard:{...staffCard},rooms:this.rooms},
      cssClass: 'medium-modal-css',
       backdropDismiss: true,
       swipeToClose: false,
     });
     await modal.present();
   }
  
  }
  